import classNames from "classnames";
import * as React from "react";

import { RadioGroupStyle } from "./radio-group-style";

interface Props<T> {
    items: readonly T[];
    title?: string;
    flat?: boolean;
    value: T | undefined;
    getName: (item: T) => string;
    getSubtitle?: (item: T) => string | undefined;
    getStyle?: (item: T) => "normal" | "disabled";
    onChange: (newValue: T) => void;
}

export default class RadioGroup<T> extends React.PureComponent<Props<T>> {
    public render(): React.ReactNode {
        const { items, value, onChange: onClick, getName: getLabel, title, getSubtitle, getStyle, flat = false } = this.props;
        return (
            <RadioGroupStyle>
                {items.map((v, i) => {
                    const label = getLabel(v);
                    const subtitle = getSubtitle?.(v);
                    const disabled = getStyle?.(v) === "disabled" && "disabled"
                    return (
                        <label key={i} >
                            <input
                                style={{ WebkitAppearance: "radio" }}
                                type="radio"
                                data-test={"radio-enum-item"}
                                checked={v === value}
                                id={label}
                                name={title}
                                className={classNames(subtitle !== undefined && "with-subtitle")}
                                onChange={e => {
                                    if (!e.target.checked) return;
                                    onClick(v);
                                }}
                            />
                            <div className={classNames({ dummy: true, flat, disabled })}></div>
                            <div className="radio-group-labels">
                                <div>{label}</div>
                                {subtitle !== undefined && <div className="radio-group-subtitle">{subtitle}</div>}
                            </div>
                        </label>
                    );
                })}
            </RadioGroupStyle>
        );
    }
}
